const UPPERCASE_REGEXP = /.*[A-Z]+.*/;
const LOWERCASE_REGEXP = /.*[a-z]+.*/;
const LETTER_REGEXP = /.*[a-zA-Z]+.*/;
const DIGIT_REGEXP = /.*[0-9]+.*/;
const SPECIAL_CHARACTERS_REGEXP = /.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]+.*/;

export const hasUppercase = (char: string) => {
	return UPPERCASE_REGEXP.test(char);
};

export const hasLowercase = (char: string) => {
	return LOWERCASE_REGEXP.test(char);
};

export const hasLetter = (char: string) => {
	return LETTER_REGEXP.test(char);
};

export const hasDigit = (char: string) => {
	return DIGIT_REGEXP.test(char);
};

export const hasSpecialCharacter = (char: string) => {
	return SPECIAL_CHARACTERS_REGEXP.test(char);
};
